import { configureStore } from "@reduxjs/toolkit";
import eventsReducer, { initialState as eventsInitialState } from "./slices/events.js";
import { loadEventsState, saveEventsState } from "./eventsStorage.js";

const persistedEvents = loadEventsState();

// Merge the persisted snapshot ON TOP of the full initialState so non-persisted
// fields (value, status, firstFetch, currentPage, limit, etc.) always start
// with their correct defaults. Without this merge, RTK's preloadedState would
// completely REPLACE the slice state, leaving those fields as `undefined`.
const preloadedEventsState = persistedEvents
  ? { ...eventsInitialState, ...persistedEvents }
  : undefined;

export const store = configureStore({
  reducer: {
    events: eventsReducer,
  },
  preloadedState: preloadedEventsState
    ? { events: preloadedEventsState }
    : undefined,
});

// Save the relevant slice fields to sessionStorage on every state change.
// We intentionally do NOT debounce: sessionStorage writes are synchronous and
// the snapshot is small. A debounce here caused a race
// condition where HMR could fire before the timer flushed, restoring a stale
// setID=null from a previous save and dropping the user back to the event list.
store.subscribe(() => {
  saveEventsState(store.getState().events);
});



